import type { DefaultOptionType } from 'antd/es/select';

export const filterOption = (input: string, option?: DefaultOptionType) => {
  return `${option?.index?.toString()} ${option?.label} ${option?.value}`
    .toLocaleLowerCase()
    .includes(input.toLocaleLowerCase());
};
